import { render, staticRenderFns } from "./tg2.vue?vue&type=template&id=596a1a44&scoped=true&"
import script from "./tg2.vue?vue&type=script&lang=js&"
export * from "./tg2.vue?vue&type=script&lang=js&"
import style0 from "./tg2.vue?vue&type=style&index=0&id=596a1a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596a1a44",
  null
  
)

export default component.exports